import { SET_MENU } from '.';

export const setMenuAction = (menu) => {
  return {
    type: SET_MENU,
    payload: menu,
  };
};
